import initVideo from './components/video-modal';
import initVisualBriefTeaser from './components/visual-brief-teaser';
import createScrollableElements, { centerAlignScrollableElement, scrollOnHover } from './components/scrollable';

// Initialise video modal
initVideo();

// Initialise visual brief teaser
const visualBrief = $('[data-visual-brief]');
initVisualBriefTeaser({elements: visualBrief});

document.addEventListener('DOMContentLoaded', () => {
    createScrollableElements();
    scrollOnHover('[data-scrollable]');
});


// Contest listings
scrollOnHover('[data-scrollable="contests"]');
centerAlignScrollableElement('[data-scrollable="contests"]');



// WEBPACK FOOTER //
// ./js/marketing/industryLandingPage.jsx